import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

function InfoDialog(props) {
    return (<>
        <Dialog
            open={props.content.open}
            onClose={() => props.close()}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle borderTop={6} borderColor={props.content.color}></DialogTitle>
            <DialogContent>
                <Grid
                    container
                    spacing={1}
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    wrap="wrap"
                >
                    <Grid item xs={3}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="flex-start"
                        >
                            <Grid item container direction="row" alignItems="center">
                                <Avatar sx={{ bgcolor: props.content.color, width: 100, height: 100 }}>
                                    {props.content.icon}
                                </Avatar>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={9}>
                        <Grid container direction="column">
                            <Grid item>
                                <Typography
                                    variant="body1"
                                    color="#2E4053"
                                    gutterBottom
                                    fontWeight="bold"
                                    fontSize={20}
                                >
                                    {" "}
                                    {props.content.title}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="body1" color="#2E4053">
                                    Se deberán abrir las siguientes rendiciones:
                                </Typography>
                            </Grid>
                            <ul>
                                {props.content.items.sort((a, b) => a.nombre_empresa.localeCompare(b.nombre_empresa)).map((item) => (
                                    <li>
                                        <Typography variant="body1" color="#2E4053">
                                            {item.nombre_empresa}: {item.rdc} (Sucursal {item.sucursal})
                                        </Typography>
                                    </li>
                                ))}
                            </ul>

                            <Typography
                                variant="body1"
                                color="textSecondary"
                                style={{ marginTop: 8 }}
                            >
                                {/* {props.confirmText} */}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    </>
    );
}

export default InfoDialog;